import PersSliderOnOff from "./subElements/persSliderOnOff"
import './mainSliderOnOff.css'

const SliderOnOff =({returnIsActive})=>{

    return(
        <PersSliderOnOff 
        returnIsActive={returnIsActive? returnIsActive:console.log}
        />
    )
}

export default SliderOnOff